import type {INumericFieldSettingsDefinition} from "../../../../../data/models/field/datatypes/Numeric";
import type {IInputPropsV5} from "../../../../widgets/input/clicktoedit/InputUtils";
import {NumberInputV5} from "./NumberInputV5";

export const NumericInputV5 = (props: IInputPropsV5<INumericFieldSettingsDefinition>) => {
	const {onInput, onChange, value, dataTypeSettings, caretPosition} = props;

	return (
		<div className="hbox field-input-container">
			<NumberInputV5
				value={value}
				onInput={onInput}
				onChange={onChange}
				decimals={dataTypeSettings.decimals}
				autoFocus={false}
				dataTypeSettings={dataTypeSettings}
				caretPosition={caretPosition}
			/>
		</div>
	);
};
